import React from "react";
import { SectionHeading, ContentSection, Paragraph } from "@vwfs-bronson/bronson-react";

class TermsAndConditionsPage extends React.Component {
  render() {
    return (
      <ContentSection pageWrap pageWrapSize="medium">
        <SectionHeading level="3" center>
          Nutzungsbedingungen für die Antragsstrecke der Volkswagen Leasing GmbH
        </SectionHeading>
        <Paragraph>Stand: März 2021</Paragraph>

        <Paragraph>
          <span className="u-block">
            <strong>1. Geltungsbereich</strong>
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">1.1</span>
          <span>
            Die Volkswagen Leasing GmbH, Gifhorner Stra&szlig;e 57, 38112
            Braunschweig (im Folgenden &#8222;VW FS&#8220; oder
            &#8222;wir&#8220;), betreibt die Online-Antragsstrecke. Diese
            richtet sich ausschlie&szlig;lich an Nutzer (im Folgenden
            &#8222;Nutzer&#8220; oder &#8222;Sie&#8220;) der VW FS in
            Deutschland. Nutzern des Dienstes werden verschiedene Angebote in
            Form von Waren und Dienstleistungen sowie online abrufbare Inhalte
            angeboten.{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">1.2</span>
          <span>
            Diese Nutzungsbedingungen gelten f&uuml;r alle
            Gesch&auml;ftsbeziehungen mit den Nutzern der Online-Antragsstrecke.{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">1.3</span>
          <span>
            Das Angebot richtet sich ausschlie&szlig;lich an Nutzer, die das 18.
            Lebensjahr vollendet haben.{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">1.4</span>
          <span>
            Die Vertragssprache ist deutsch. Werden alternative Sprachversionen
            angeboten, ist alleine die deutsche Fassung rechtlich
            ma&szlig;geblich.{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">1.5</span>
          <span>
            Die aktuell g&uuml;ltigen Nutzungsbedingungen k&ouml;nnen unter{" "}
            <a href="https://heycarselect.de.leasing-online.vwfs.io/Nutzungsbedingungen">
              https://heycarselect.de.leasing-online.vwfs.io/Nutzungsbedingungen
            </a>
          </span>
          <span> aufgerufen, gespeichert und ausgedruckt werden. </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">
            <strong>2. Nutzung</strong>
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">2.1</span>
          <span>
            Die Nutzung der Antragsstrecke ist ausschlie&szlig;lich im
            vertraglich vorgesehenen Umfang und entsprechend dem
            verf&uuml;gbaren Angeboten zul&auml;ssig.
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">2.2</span>
          <span>
            Es besteht kein Anspruch des Nutzers auf Aufrechterhaltung einzelner
            Funktionalit&auml;ten des Dienstes. Wir sind um einen
            st&ouml;rungsfreien Betrieb und die Aufrechterhaltung der Angebote
            bem&uuml;ht. Dies beschr&auml;nkt sich naturgem&auml;&szlig; auf die
            Leistungen, auf die wir Einfluss haben.{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">2.3</span>
          <span>
             Wir k&ouml;nnen das Angebot ganz oder teilweise, zeitweise oder auf
            Dauer beschr&auml;nken, wenn dies im Hinblick auf Wartungsarbeiten,
            Kapazit&auml;tsgrenzen, die Sicherheit oder Integrit&auml;t der
            Server, zur Durchf&uuml;hrung technischer Ma&szlig;nahmen,
            Gesundheit unserer Mitarbeiter oder aufgrund anderer Ereignisse, die
            nicht in Machtbereich der VW FS stehen, einschr&auml;nken.{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">2.4</span>
          <span>
            S&auml;mtliche Rechte an den Inhalten des Dienstes liegen bei der VW
            FS. Dem Nutzer ist die Vervielf&auml;ltigung, Verbreitung und/oder
            Ver&ouml;ffentlichung von Inhalten untersagt, die wir in der
            Antragsstrecke eingestellt haben. Der Nutzer darf die durch Abfragen
            und Nutzung des Dienstes gewonnenen oder &uuml;ber den Dienst
            zug&auml;nglich gemachten Daten und Inhalte weder vollst&auml;ndig,
            noch teilweise oder auszugsweise verwenden
          </span>
        </Paragraph>

        <ul>
          <li>
            zum Aufbau einer eigenen Datenbank in jeder medialen Form und/oder
          </li>

          <li>
            f&uuml;r eine gewerbliche Datenverwertung oder Auskunftserteilung
            und/oder
          </li>

          <li>f&uuml;r eine sonstige gewerbliche Verwertung.</li>
        </ul>

        <Paragraph>
          <span className="u-block">2.5</span>
          <span>
            Ohne vorherige Zustimmung durch die VW FS d&uuml;rfen Inhalte der
            Antragsstrecke nicht kopiert, verbreitet vervielf&auml;ltigt oder in
            sonstiger Weise genutzt werden. Das gilt insbesondere auch f&uuml;r
            das Kopieren mit Hilfe von Robots, Crawlern oder anderen
            automatischen Verfahren.{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">2.6</span>
          <span>
            Wir behalten uns das Recht vor, die Antragsstrecke und die darauf
            enthaltenen Angebote weiterzuentwickeln und Ihnen nach unserem
            eigenen Ermessen zu Verf&uuml;gung zu stellen. Ein Anspruch auf
            bestimmte Angebote, Funktionalit&auml;ten oder Weiterentwicklungen
            besteht indes nicht.
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">
            <strong>
              3. Kreditw&uuml;rdigkeitspr&uuml;fung &uuml;ber den DAC
            </strong>
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">3.1</span>
          <span>
            Sie haben die M&ouml;glichkeit im Rahmen der Nutzung der
            Antragsstrecke mittels des Angebotes des Digital Account Checks
            (DAC) der FinTecSystems GmbH, Gottfried-Keller-Str. 33, 81245
            M&uuml;nchen, Ihre Bonit&auml;t zu pr&uuml;fen und nachzuweisen.
            Diese unverbindliche Bonit&auml;tspr&uuml;fung ist f&uuml;r Sie
            optional.
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">3.2</span>
          <span>
            Im Rahmen des DAC wird FinTecSystems einmalig auf Ihr Konto
            zugreifen, um die monatlichen Einnahmen und Ausgaben in dem
            angegebenen Konto automatisiert zu ermitteln (Bonit&auml;t).{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">3.3</span>
          <span>
            Nach erfolgreicher Ermittlung der Bonit&auml;t wird diese an die
            Volkswagen Leasing GmbH &uuml;bermittelt, die diese zur
            unverbindlichen Kreditw&uuml;rdigkeitspr&uuml;fung verarbeitet.
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">3.4</span>
          <span>
            Es gelten die Bedingungen der{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://manage.xs2a.com/tos"
            >
              FinTecSystems GmbH
            </a>
            .
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">
            <strong>4. Vertragsschluss mithilfe von IDnow </strong>
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">4.1</span>
          <span>
            Sie haben die M&ouml;glichkeit sich im Rahmen der Nutzung der
            Antragsstrecke mittels des Angebotes der IDnow GmbH,
            Auenstra&szlig;e 100, 80469 M&uuml;nchen zu legitimieren und das von
            Ihnen ausgew&auml;hlte Angebot digital zu unterzeichnen. Die
            Services von IDnow sind Voraussetzung f&uuml;r den Vertragsschluss.
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">4.2</span>
          <span>
            F&uuml;r die Legitimation werden Sie zu dem Dienstleister IDnow
            weitergeleitet. Dieser best&auml;tigt mittels eines
            Videoident-Verfahrens Ihre Identit&auml;t. Zur Identifizierung
            m&uuml;ssen die Vorder- und R&uuml;ckseite Ihres g&uuml;ltigen
            Personalausweises oder Reisepasses vor Ihre Webcam/Kamera gehalten
            werden, um das Ausweisdokument entsprechend verifizieren zu
            k&ouml;nnen (Fotografien des Ausweises werden angefertigt und die
            Ausweisnummer wird erfasst).{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">4.3</span>
          <span>
            Die Qualifizierte Elektronische Signatur (QES) ersetzt Ihre
            handschriftliche Unterschrift auf den Vertragsdokumenten. Hierzu
            wird Ihnen von IDnow eine SMS TAN auf Ihr pers&ouml;nliches
            Mobilfunkger&auml;t zugesendet. Mittels Eingabe dieser TAN
            k&ouml;nnen von Ihnen alle zuvor besprochenen Vertragsunterlagen
            elektronisch signiert werden. Im Nachgang erhalten Sie die
            Vertragsunterlagen per Mail und k&ouml;nnen.
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">4.4</span>
          <span>
            Es gelten die Bedingungen von{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://go.idnow.de/agb"
            >
              IDnow
            </a>
          </span>
          <span>.</span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">
            <strong>5. Gew&auml;hrleistung </strong>
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">5.1</span>
          <span>
            Sie sind f&uuml;r die Richtigkeit der von Ihnen eingegebenen Daten
            verantwortlich.
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">5.2</span>
          <span>
            Wir &uuml;bernehmen Gew&auml;hr f&uuml;r die Funktionsbereitschaft
            des Dienstes in dem in diesen Nutzungsbedingungen beschriebenen
            Umfang, soweit wir darauf Einfluss nehmen k&ouml;nnen. Wir haben
            insbesondere keinen Einfluss auf die Funktionsf&auml;higkeit der
            Zugangsm&ouml;glichkeit &uuml;ber &ouml;ffentliche Netze.{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">
            <strong>6. Schlussbestimmungen</strong>
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">6.1</span>
          <span>
            Sollten diese Nutzungsbedingungen unwirksame Regelungen enthalten
            oder l&uuml;ckenhaft sein, bleibt die Wirksamkeit des mithilfe
            dieses Dienstes angebahnten Vertrages im &Uuml;brigen
            unber&uuml;hrt.{" "}
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">6.2</span>
          <span>
            Erf&uuml;llungsort f&uuml;r alle Rechte und Pflichten der
            Vertragsparteien, die sich aus diesem Vertrag ergeben, ist der Sitz
            der VW FS in Braunschweig.
          </span>
        </Paragraph>

        <Paragraph>
          <span className="u-block">6.3</span>
          <span>
            Auf den vorliegenden Vertrag ist ausschlie&szlig;lich deutsches
            Recht unter Ausschluss des UN-Kaufrechts anwendbar.
            Ausschlie&szlig;licher Gerichtsstand f&uuml;r alle aus oder im
            Zusammenhang mit diesem Vertrag entstehenden Streitigkeiten ist
            Braunschweig.{" "}
          </span>
        </Paragraph>
      </ContentSection>
    );
  }
}

export { TermsAndConditionsPage };
